import _extends from "@babel/runtime/helpers/extends";
import { ProductHat as ProductHatUI } from '@wix/premium-purchase-platform/@ui';
import classNames from 'classnames';
import React from 'react';
import { useIsStudioNewUi, useProductHat } from '../../hooks';
import s from './ProductHat.scss';
export const ProductHat = _ref => {
  let {
    productId,
    textWeight,
    borderRadius,
    height,
    background
  } = _ref;
  const {
    text,
    background: hatBackground,
    hasHat,
    isCurrentPlanHat
  } = useProductHat({
    productId
  });
  const isStudioNewUi = useIsStudioNewUi();
  if (!hasHat) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ProductHatUI, _extends({
    hatText: text,
    textWhite: false,
    background: background ?? hatBackground,
    width: "100%"
  }, textWeight && {
    textWeight
  }, borderRadius && {
    borderRadius
  }, height && {
    height
  }, isStudioNewUi && {
    textProps: {
      className: classNames(s.newUiHatText, {
        [s.newUiCurrentPlanHatText]: isCurrentPlanHat
      }),
      size: 'small'
    }
  }));
};
//# sourceMappingURL=ProductHat.js.map